<template>
  <div class="lots-list tab-table p-2">
    <relations-table :exclude-columns="['related_to_customer_uuid', 'related_to_receipt_uuid']"
                     :exclude-search-fields="['related_to_customer_uuid']"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import RelationsTable from "@/modules/relations/RelationsTable";

  const {mapState} = createNamespacedHelpers('receipts');
  const {mapActions: relationsMapActions} = createNamespacedHelpers('relations');

  export default {
    name: "RelationsList",
    components: {RelationsTable},
    data() {
      return {}
    },
    computed: {
      ...mapState({
        receipt: state => state.view.currentReceipt
      })
    },
    methods: {
      ...relationsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'receipt',
        extraFilters: {object_uuid: this.receipt.uuid},
        object: this.receipt
      })
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .btn-table-actions {
    display: none;
  }
</style>
